import { RigAvailabilityBase } from './base/rig-availability-base';

export class RigAvailability extends RigAvailabilityBase { }